window.VegasCatalog.Order = {
	make: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			if (callback) {
				callback(data);
			}
		})
	},
};

$(document).ready(function () {
	let $formOrder = $("#form-cart");

	$formOrder.find('[name=delivery_id]').on('change', function () {
		let id = $(this).attr('id'),
			val = parseInt($(this).val()),
			$containerOrder = $(this).closest('.catalog-cart--totals'),
			$containerDelivery = $containerOrder.find('.delivery-area--placement');

		// set show & active
		$containerDelivery.find('.active').removeClass('show active');
		let $currentDelivery = $containerDelivery.find('[data-id=' + id + ']');
		$currentDelivery.addClass('show active');

		// use required
		$('.delivery-area--placement .toggle-required').removeAttr('required');
		$currentDelivery.find('.toggle-required').attr('required', 'required');

		VegasCatalog.Cart.updateTotalAll();
	});

	//$formOrder.find('[name=delivery_id]:checked').trigger('change')

	$formOrder.on('submit', function () {
		let $inputRecaptcha = $formOrder.find('[name=g-recaptcha-response]');

		$('.catalog-cart--preload').addClass('show');

		if (!$inputRecaptcha.val()) {
			let action = $inputRecaptcha.data('action');
			formRecaptcha(action, (token) => {
				$inputRecaptcha.val(token);
				$formOrder.get(0).requestSubmit();
			});

			return false;
		}

		VegasCatalog.Order.make($formOrder, function (data) {
			if (data.error) {
				$('.catalog-cart--preload').removeClass('show')
				alert(data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formOrder.on("keydown", function (event) {
		return event.key !== "Enter";
	});
});
